import React, { useState, useEffect, createContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { timeOutCierreSesions } from "../config/constantes";
import {

  listado_etiquetas,
  listado_idiomas,
} from "../services/public/Public";
import { validarFormatoFecha } from "../utils/Fechas/validarFormatoFecha";
import { crearTokenGlo } from "../utils/validarTokenGlo/validarTokenGlo";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({});
  const [listadoEtiquetas, setListadoEtiquetas] = useState([]);
  const [listadoIdiomas, setListadoIdiomas] = useState([]);
  const [seleccionIdiomas, setSeleccionIdiomas] = useState(0);
  const [listadoImgLogin, setListadoImgLogin] = useState([]);
  const [loadingAuth, setLoadingAuth] = useState(false);

  const maxSessionTime = Number(timeOutCierreSesions); // Tiempo máximo de sesión en minutos

  const localStorageKey = 'sessionStartTime';
  const navigate = useNavigate();

  let location = useLocation();

  const { pathname } = location;

  useEffect(() => {

  }, [pathname])

  useEffect(() => {
    const renovacionToken = () => {
      let intervalo = setInterval(async () => {
        try {
          let tokenSe = localStorage.getItem("token");
          let tokenGlos =
            localStorage.getItem("tokenGlo") === ""
              ? null
              : JSON.parse(localStorage.getItem("tokenGlo"));

          if (tokenSe) {

            if (
              validarFormatoFecha(tokenGlos?.expires_in) &&
              tokenGlos?.access_token &&
              tokenGlos?.key_encrypt
            ) {


              if (new Date(tokenGlos.expires_in) - new Date() <= 300000) {



                await crearTokenGlo(setAuth, navigate);

                return () => clearInterval(intervalo);

              }

              return () => clearInterval(intervalo);

            } else {

              throw new Error("No se tiene el token correcto")

            }
          }
        } catch (error) {
          if (!pathname.includes("/payme/")) {
            navigate("/auth");
          }
          localStorage.removeItem("tokenGlo");
          localStorage.removeItem("token");

          return () => clearInterval(intervalo);
        }
      }, 1000);
      return () => clearInterval(intervalo);
    };
    if (localStorage.getItem("token")) {
      renovacionToken();
    }


  }, [auth]);

  useEffect(() => {
    listadoIdiomas.length > 0 &&
      !localStorage.getItem("idioma") &&
      setSeleccionIdiomas(listadoIdiomas[0].cidioma);
  }, [listadoIdiomas]);




  useEffect(() => {
    const autenticarUsuario = () => {
      const token = localStorage.getItem("token");

      if (!token) {
        return;
      }
      try {


        setAuth({
          _id: "12313123",
          nombre: "anonimus",
          correo: "anonimus@gmail.com",
        });

        const rutasPrivadasPayme = [
          "/payme/finish",
          "/payme/pre-respuesta",
          "/payme/notificacion-pago"
        ];

        if (!rutasPrivadasPayme.includes(pathname)) {
          navigate("/");
        } else {
          console.log("AuthProvider: Detectada ruta de pago, se cancela redirección a Inicio");
        }

      } catch (error) {
        setAuth({});

      }
    };
    autenticarUsuario();



    try {
      let storageIdioma = JSON.parse(sessionStorage.getItem("listIdiomas"));

      if (storageIdioma) {
        setListadoIdiomas(storageIdioma)
      } else {
        listado_idiomas(setListadoIdiomas, setLoadingAuth);
      }


    } catch (error) {
    } finally {
    }





    if (localStorage.getItem("idioma")) {
      setSeleccionIdiomas(Number(localStorage.getItem("idioma")));
    }


    if (!sessionStorage.getItem("etiquetas")) {
      //el estado seleccionIdiomas se demora en tomar el ultimo valor seteado entonces si en caso el valor inicializado en 0 que me tome del localstorage la seleccion
      let selectIdioma =
        seleccionIdiomas == 0
          ? localStorage.getItem("idioma")
          : 1;

      listado_etiquetas(selectIdioma, setListadoEtiquetas, setLoadingAuth);
    }

    if (sessionStorage.getItem("etiquetas")) {

      const etiquetas = JSON.parse(sessionStorage.getItem("etiquetas"));

      setListadoEtiquetas(etiquetas);

    }


  }, []);

  useEffect(() => {


    let timeoutId;


    const getLastActivityTime = () => {
      const storedTime = localStorage.getItem(localStorageKey);

      return storedTime ? parseInt(storedTime, 10) : null;
    };


    const setLastActivityTime = () => {
      localStorage.setItem(localStorageKey, Date.now().toString());
    };


    const checkSessionTimeout = () => {
      const lastActivityTime = getLastActivityTime();

      if (lastActivityTime) {
        const currentTime = Date.now();
        const timeSinceLastActivity = currentTime - lastActivityTime;

        if (timeSinceLastActivity >= maxSessionTime * 60 * 1000) {
          logout();
        } else {
          const remainingTime = maxSessionTime * 60 * 1000 - timeSinceLastActivity;
          timeoutId = setTimeout(logout, remainingTime);
        }
      }
    };


    const logout = () => {
      localStorage.removeItem(localStorageKey);
      localStorage.removeItem("token");
      localStorage.removeItem("tokenGlo");
      setAuth({});
      window.location.reload(); // Recargar la página
    };


    const resetSessionTimeout = () => {
      clearTimeout(timeoutId); // Borrar el temporizador actual
      setLastActivityTime(); // Actualizar la marca de tiempo de actividad
      checkSessionTimeout(); // Verificar el tiempo de sesión nuevamente
    };


    document.addEventListener('click', resetSessionTimeout);
    document.addEventListener('mousemove', resetSessionTimeout);
    document.addEventListener('keydown', resetSessionTimeout);
    document.addEventListener('scroll', resetSessionTimeout);
    document.addEventListener('wheel', resetSessionTimeout);
    document.addEventListener('mousewheel', resetSessionTimeout);
    document.addEventListener('mousedown', resetSessionTimeout);
    document.addEventListener('DOMMouseScroll', resetSessionTimeout);
    document.addEventListener('touchstart', resetSessionTimeout);
    document.addEventListener('touchmove', resetSessionTimeout);
    document.addEventListener('MSPointerDown', resetSessionTimeout);
    document.addEventListener('MSPointerMove', resetSessionTimeout);
    document.addEventListener('visibilitychange', resetSessionTimeout);


    checkSessionTimeout();

    // Limpieza de event listeners al desmontar el componente para evitar fugas de memoria
    return () => {
      clearTimeout(timeoutId); // Limpiar el temporizador

      document.removeEventListener('click', resetSessionTimeout);
      document.removeEventListener('mousemove', resetSessionTimeout);
      document.removeEventListener('keydown', resetSessionTimeout);
      document.removeEventListener('scroll', resetSessionTimeout);
      document.removeEventListener('wheel', resetSessionTimeout);
      document.removeEventListener('mousewheel', resetSessionTimeout);
      document.removeEventListener('mousedown', resetSessionTimeout);
      document.removeEventListener('DOMMouseScroll', resetSessionTimeout);
      document.removeEventListener('touchstart', resetSessionTimeout);
      document.removeEventListener('touchmove', resetSessionTimeout);
      document.removeEventListener('MSPointerDown', resetSessionTimeout);
      document.removeEventListener('MSPointerMove', resetSessionTimeout);
      document.removeEventListener('visibilitychange', resetSessionTimeout);
    };
  }, []);


  useEffect(() => {

  }, [listadoImgLogin]);

  return (
    <AuthContext.Provider
      value={{
        auth,
        setAuth,
        listadoEtiquetas,
        setListadoEtiquetas,
        listadoIdiomas,
        setListadoIdiomas,
        seleccionIdiomas,
        setSeleccionIdiomas,
        listadoImgLogin,
        setListadoImgLogin,
        loadingAuth, setLoadingAuth
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext };

export default AuthProvider;
